import {useQuery} from '@tanstack/react-query';
import {getProjectSummary} from '@/services/points';
import {pointsKeys} from '@/hooks/points/queryKeys';
import {queryClient} from '@/utils/queryClient';
import type {ProjectSummaryData} from '@/services/points/interface';

export const invalidateProjectSummary = () =>
    queryClient.invalidateQueries({queryKey: pointsKeys.projectSummary()});

export const useProjectSummary = () => {
    const query = useQuery<ProjectSummaryData>({
        queryKey: pointsKeys.projectSummary(),
        queryFn: getProjectSummary,
        staleTime: 0,
        refetchOnMount: 'always',
    });

    return {
        ...query,
        projects: query.data?.projects ?? [],
    };
};
